/*if(window.innerWidth < 960){
    let menuItems = document.querySelectorAll('.menu .nav-main-item')
    menuItems.forEach(function(item) {
        item.addEventListener('click',function(){
            let activeItem = document.querySelector('.nav-main-item.active')
            console.log(activeItem)
            this.classList.toggle('active')
            if(activeItem){
                activeItem.classList.remove('active')
            }
        })
    })
}*/

if(window.innerWidth < 960){
    let menuItems = document.querySelectorAll('.menu .nav-main-item')
    let buttonMenu = document.querySelector('.nav-main_icon')
    menuItems.forEach(function(item) {
        item.addEventListener('click',function(){
            let activeItem = document.querySelector('.nav-main-item.active')
            console.log(activeItem)
            this.classList.toggle('active')
            if(activeItem){
                activeItem.classList.remove('active')
            }
        })
    })
    buttonMenu.addEventListener('click',function(){
        let menuPosition = document.querySelector('#nav-main')
        menuPosition.classList.toggle('menuposition')
    })
}
if(window.innerWidth >= 960){
    let menuItems = document.querySelectorAll('.menu .nav-main-item')
    menuItems.forEach(function(item) {
        let menuPosition = document.querySelector('#nav-main')
        item.addEventListener('mouseenter',function(){
            this.classList.toggle('active')
            menuPosition.classList.toggle('menuposition')
        })
        item.addEventListener('mouseleave',function(){
            this.classList.remove('active')
            menuPosition.classList.remove('menuposition')
        })
    })
}

/* Menu text separation */
let htmlItemMenu = document.querySelectorAll('.nav-main-link');
let i = 0;
while (i < htmlItemMenu.length) {
    let stringItem = htmlItemMenu[i].innerText;
    let splitItem = stringItem.split(" ");
    let textSpan = '<span>' + splitItem.shift() + '&nbsp;</span>';
    let texteHTML = textSpan + splitItem;
    htmlItemMenu[i].innerHTML = texteHTML ;
    i++;
  }
